import * as Sentry from '@sentry/react';

export const initSentry = () => {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        tracePropagationTargets: ['localhost'],
        integrations: [
            Sentry.browserTracingIntegration(),
            // Sentry.replayIntegration()
        ],
        tracesSampleRate: 1.0,
        environment: import.meta.env.MODE,
        // replaysOnErrorSampleRate: 1.0,
        // replaysSessionSampleRate: 1.0,
        beforeSend(event) {
            // Don't send events in development
            // if (import.meta.env.DEV) {
            //     return null;
            // }
            return event;
        },
    });
};